import Axios from "axios";
import { createPinia } from "pinia";

const Pinia = createPinia();
Pinia.use(({ store }) => {
  store.axios = Axios;
});

export default Pinia;
